import { Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Header from './Header.jsx'
import Footer from './Footer.jsx'
import AnnouncementBanner from './AnnouncementBanner.jsx'
import { analytics } from '../../utils/analytics.js'

export default function Layout() {
  const location = useLocation()

  useEffect(() => {
    analytics.pageView(location.pathname)
  }, [location.pathname])

  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Background blur blobs — fixed, behind everything */}
      <div className="fixed inset-0 z-[-1] overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-primary/10 blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-accent/10 blur-[120px]" />
      </div>

      <Header />
      <AnnouncementBanner />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
